
/**
 * This file handles the Hello Retail tracking setup and consent handling with Complianz GDPR plugin.
 */

/**
 * Initialize Hello Retail tracking with Complianz GDPR plugin consent handling.
 * This means that we push an opt out or opt in based on the user's consent preferences from the start when we load the page.
 */
hrq = window.hrq || [];
hrq.push( function( sdk ) {
	sdk.setTrackingOptOut( NSHR?.marketing_consent ? false : true );
} );

document.addEventListener( 'cmplz_status_change', reactToConsentChange );

/**
 * Handles consent status changes from the Complianz GDPR plugin and updates Hello Retail tracking settings accordingly.
 * This function is triggered when the user changes their consent preferences and specifically handles marketing consent
 * to enable or disable Hello Retail tracking based on the user's choice.
 *
 * @param {Object} consentData                 - The consent data object from the Complianz plugin
 * @param {Object} consentData.detail          - The detailed consent information
 * @param {string} consentData.detail.category - The consent category that changed (e.g., 'marketing', 'functional')
 * @param {string} consentData.detail.value    - The consent value, either 'allow' or 'deny'
 * @return {void} This function does not return a value
 */
function reactToConsentChange( consentData ) {
	const category = consentData.detail.category;
	const categoryAccepted = consentData.detail.value === 'allow';

	if ( category === 'marketing' ) {
		hrq = window.hrq || [];
		hrq.push( function( sdk ) {
			sdk.setTrackingOptOut( categoryAccepted ? false : true );
		} );
	}
}
